// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var LogIO = require("../LogIO.bs.js");
var TypeUtils = require("../types/TypeUtils.bs.js");
var AxiosUtils = require("../AxiosUtils.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_Geocode = require("../types/CommonTypes_Geocode.bs.js");
var CommonTypes_ZipCode = require("../types/CommonTypes_ZipCode.bs.js");

var Token = TypeUtils.MakeOpaqueStringType({});

function toString(param) {
  switch (param) {
    case /* Ok */0 :
        return "OK";
    case /* ZeroResults */1 :
        return "ZERO_RESULTS";
    case /* OverDailyLimit */2 :
        return "OVER_DAILY_LIMIT";
    case /* OverQueryLimit */3 :
        return "OVER_QUERY_LIMIT";
    case /* RequestDenied */4 :
        return "REQUEST_DENIED";
    case /* InvalidRequest */5 :
        return "INVALID_REQUEST";
    case /* UnknownError */6 :
        return "UNKNOWN_ERROR";
    
  }
}

function fromString(param) {
  return Relude_Globals.$great$great(Relude_String.toUpperCase, (function (param) {
                switch (param) {
                  case "INVALID_REQUEST" :
                      return /* InvalidRequest */5;
                  case "OK" :
                      return /* Ok */0;
                  case "OVER_DAILY_LIMIT" :
                      return /* OverDailyLimit */2;
                  case "OVER_QUERY_LIMIT" :
                      return /* OverQueryLimit */3;
                  case "REQUEST_DENIED" :
                      return /* RequestDenied */4;
                  case "UNKNOWN_ERROR" :
                      return /* UnknownError */6;
                  case "ZERO_RESULTS" :
                      return /* ZeroResults */1;
                  default:
                    return ;
                }
              }), param);
}

var decode = Curry._1(Json.Decode.variantFromString, fromString);

var Status = {
  toString: toString,
  fromString: fromString,
  decode: decode
};

function toString$1(error) {
  if (typeof error !== "number") {
    return "Parse Error: " + error._0;
  }
  switch (error) {
    case /* ZeroResults */0 :
        return "Zero Results";
    case /* OverDailyLimit */1 :
        return "Over Daily Limit";
    case /* OverQueryLimit */2 :
        return "Over Query Limit";
    case /* RequestDenied */3 :
        return "Request Denied";
    case /* InvalidRequest */4 :
        return "Invalid Request";
    case /* UnknownError */5 :
        return "Unknown Error";
    
  }
}

var $$Error = {
  toString: toString$1
};

function make(results, status) {
  switch (status) {
    case /* Ok */0 :
        if (results.length !== 0) {
          return {
                  TAG: /* Ok */0,
                  _0: results
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: /* ZeroResults */0
                };
        }
    case /* ZeroResults */1 :
        return {
                TAG: /* Error */1,
                _0: /* ZeroResults */0
              };
    case /* OverDailyLimit */2 :
        return {
                TAG: /* Error */1,
                _0: /* OverDailyLimit */1
              };
    case /* OverQueryLimit */3 :
        return {
                TAG: /* Error */1,
                _0: /* OverQueryLimit */2
              };
    case /* RequestDenied */4 :
        return {
                TAG: /* Error */1,
                _0: /* RequestDenied */3
              };
    case /* InvalidRequest */5 :
        return {
                TAG: /* Error */1,
                _0: /* InvalidRequest */4
              };
    case /* UnknownError */6 :
        return {
                TAG: /* Error */1,
                _0: /* UnknownError */5
              };
    
  }
}

function decode$1(resultsFieldNameOpt, resultDecoder, json) {
  var resultsFieldName = resultsFieldNameOpt !== undefined ? resultsFieldNameOpt : "results";
  return Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$$great, make, Curry._3(Json.Decode.field, resultsFieldName, Curry._1(Json.Decode.array, resultDecoder), json)), Curry._3(Json.Decode.field, "status", decode, json));
}

function mapResponseError(parseError) {
  if (parseError.TAG === /* Error */0) {
    return /* UnknownError */5;
  } else {
    return /* ParseError */{
            _0: parseError._0
          };
  }
}

var $$Response = {
  Status: Status,
  $$Error: $$Error,
  make: make,
  decode: decode$1,
  mapResponseError: mapResponseError
};

function makeAddressUrl(token, address) {
  return "https://maps.googleapis.com/maps/api/geocode/json?address=" + (encodeURIComponent(address) + ("&key=" + encodeURIComponent(Curry._1(Token.toString, token))));
}

function makeZipCodeUrl(token, zipCode) {
  return "https://maps.googleapis.com/maps/api/geocode/json?components=country:US|postal_code:" + (Curry._1(CommonTypes_ZipCode.toString, zipCode) + ("&key=" + encodeURIComponent(Curry._1(Token.toString, token))));
}

function make$1(longName, shortName, types) {
  return {
          longName: longName,
          shortName: shortName,
          types: types
        };
}

function decode$2(json) {
  return Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$$great, make$1, Curry._3(Json.Decode.field, "long_name", Json.Decode.string, json)), Curry._3(Json.Decode.field, "short_name", Json.Decode.string, json)), Curry._3(Json.Decode.field, "types", Curry._1(Json.Decode.array, Json.Decode.string), json));
}

var AddressComponent = {
  make: make$1,
  decode: decode$2
};

function make$2(northeast, southwest) {
  return {
          northeast: northeast,
          southwest: southwest
        };
}

function decode$3(json) {
  return Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$$great, make$2, Curry._3(Json.Decode.field, "northeast", CommonTypes_Geocode.decode, json)), Curry._3(Json.Decode.field, "southwest", CommonTypes_Geocode.decode, json));
}

var Bounds = {
  make: make$2,
  decode: decode$3
};

function make$3(bounds, $$location, viewport) {
  return {
          bounds: bounds,
          location: $$location,
          viewport: viewport
        };
}

function decode$4(json) {
  return Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$$great, make$3, Curry._3(Json.Decode.optionalField, "bounds", decode$3, json)), Curry._3(Json.Decode.field, "location", CommonTypes_Geocode.decode, json)), Curry._3(Json.Decode.optionalField, "viewport", decode$3, json));
}

var Geometry = {
  Bounds: Bounds,
  make: make$3,
  decode: decode$4
};

function make$4(addressComponents, formattedAddress, geometry, partialMatch, placeId) {
  return {
          addressComponents: addressComponents,
          formattedAddress: formattedAddress,
          geometry: geometry,
          partialMatch: Relude_Option.getOrElse(false, partialMatch),
          placeId: placeId,
          zipcode: Curry._2(Relude_Option.flatMap, (function (param) {
                  return CommonTypes_ZipCode.fromString(param.shortName);
                }), Curry._2(Relude_Array.find, (function (param) {
                      return Relude_Option.isSome(Curry._2(Relude_Array.find, (function (param) {
                                        return Relude_String.eq("postal_code", param);
                                      }), param.types));
                    }), addressComponents))
        };
}

function decode$5(json) {
  return Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$$great, make$4, Curry._3(Json.Decode.field, "address_components", Curry._1(Json.Decode.array, decode$2), json)), Curry._3(Json.Decode.field, "formatted_address", Json.Decode.string, json)), Curry._3(Json.Decode.field, "geometry", decode$4, json)), Curry._3(Json.Decode.optionalField, "partial_match", Json.Decode.$$boolean, json)), Curry._3(Json.Decode.field, "place_id", Json.Decode.string, json));
}

var GeocodeResult = {
  make: make$4,
  decode: decode$5
};

function geocodeAddress(token, address) {
  var partial_arg = Curry._1(LogIO.$$throw, /* ZeroResults */0);
  var partial_arg$1 = function (param) {
    return Relude_Option.fold(partial_arg, LogIO.pure, param);
  };
  var partial_arg$2 = function (param) {
    return Relude_Globals.$great$great(Relude_Array.head, partial_arg$1, param);
  };
  return LogIO.flatMap(undefined, undefined, undefined, (function (param) {
                return Relude_Result.fold(LogIO.$$throw, partial_arg$2, param);
              }), LogIO.mapError(undefined, undefined, undefined, mapResponseError, AxiosUtils.makeNetworkCallAndDecode(undefined, undefined, undefined, (function (param) {
                          return decode$1(undefined, decode$5, param);
                        }))(makeAddressUrl(token, address))));
}

function geocodeZipCode(token, zipCode) {
  var partial_arg = Curry._1(LogIO.$$throw, /* ZeroResults */0);
  var partial_arg$1 = function (param) {
    return Relude_Option.fold(partial_arg, LogIO.pure, param);
  };
  var partial_arg$2 = function (param) {
    return Relude_Globals.$great$great(Relude_Array.head, partial_arg$1, param);
  };
  return LogIO.flatMap(undefined, undefined, undefined, (function (param) {
                return Relude_Result.fold(LogIO.$$throw, partial_arg$2, param);
              }), LogIO.mapError(undefined, undefined, undefined, mapResponseError, AxiosUtils.makeNetworkCallAndDecode(undefined, undefined, undefined, (function (param) {
                          return decode$1(undefined, decode$5, param);
                        }))(makeZipCodeUrl(token, zipCode))));
}

var Geocoding = {
  makeAddressUrl: makeAddressUrl,
  makeZipCodeUrl: makeZipCodeUrl,
  AddressComponent: AddressComponent,
  Geometry: Geometry,
  GeocodeResult: GeocodeResult,
  geocodeAddress: geocodeAddress,
  geocodeZipCode: geocodeZipCode
};

var Maps = {
  Geocoding: Geocoding
};

function makeLookupUrl(sessionToken, token, input) {
  return "https://maps.googleapis.com/maps/api/place/autocomplete/json?input=" + (encodeURIComponent(input) + ("&sessiontoken=" + (encodeURIComponent(sessionToken) + ("&key=" + (encodeURIComponent(Curry._1(Token.toString, token)) + "&types=address&components=country:us")))));
}

function decode$6(json) {
  return Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$$great, (function (description, placeId) {
                    return {
                            description: description,
                            placeId: placeId
                          };
                  }), Curry._3(Json.Decode.field, "description", Json.Decode.string, json)), Curry._3(Json.Decode.field, "place_id", Json.Decode.string, json));
}

var LookupResult = {
  decode: decode$6
};

function lookup(sessionToken, token) {
  var partial_arg = Curry._1(LogIO.$$throw, /* ZeroResults */0);
  var partial_arg$1 = function (param) {
    return Relude_Option.fold(partial_arg, LogIO.pure, param);
  };
  var partial_arg$2 = Relude_Option.reject(Relude_Array.isEmpty);
  var partial_arg$3 = function (param) {
    return Relude_Globals.$great$great(Relude_Option.pure, partial_arg$2, param);
  };
  var partial_arg$4 = function (param) {
    return Relude_Globals.$great$great(partial_arg$3, partial_arg$1, param);
  };
  var partial_arg$5 = function (param) {
    return Relude_Result.fold(LogIO.$$throw, partial_arg$4, param);
  };
  var partial_arg$6 = function (param) {
    return LogIO.flatMap(undefined, undefined, undefined, partial_arg$5, param);
  };
  var partial_arg$7 = "predictions";
  var partial_arg$8 = AxiosUtils.makeNetworkCallAndDecode(undefined, undefined, undefined, (function (param) {
          return decode$1(partial_arg$7, decode$6, param);
        }));
  var partial_arg$9 = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return makeLookupUrl(sessionToken, token, param);
                }), partial_arg$8, param);
  };
  var partial_arg$10 = function (param) {
    return Relude_Globals.$great$great(partial_arg$9, (function (param) {
                  return LogIO.mapError(undefined, undefined, undefined, mapResponseError, param);
                }), param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$10, partial_arg$6, param);
  };
}

var Address = {
  makeLookupUrl: makeLookupUrl,
  LookupResult: LookupResult,
  lookup: lookup
};

exports.Token = Token;
exports.$$Response = $$Response;
exports.Maps = Maps;
exports.Address = Address;
/* Token Not a pure module */
